"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = require("../Typography");

var _Tab = require("./Tab.style");

var Tab = (0, _react.forwardRef)(function (_ref, ref) {
  var fullWidth = _ref.fullWidth,
      tabContent = _ref.tabContent,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_Tab.TabItem, {
    isSelected: isSelected,
    onClick: onClick,
    ref: ref,
    fullWidth: fullWidth
  }, /*#__PURE__*/_react.default.createElement(_Typography.Body, null, tabContent === null || tabContent === void 0 ? void 0 : tabContent.title));
});
Tab.propTypes = {
  fullWidth: _propTypes.default.bool.isRequired,
  tabContent: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired
  }).isRequired,
  isSelected: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
Tab.defaultProps = {
  isSelected: false,
  onClick: function onClick() {}
};
var _default = Tab;
exports.default = _default;